// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const DealerDisplayFormat = t.struct({
    allowedDisplayFormats: t.Array,
    key: t.String,
    value: t.String
}, {
    name: 'DealerDisplayFormat',
    strict: true
});

export const getDefaultState = () => new DealerDisplayFormat({
    allowedDisplayFormats: [],
    key: '',
    value: ''
});

export default DealerDisplayFormat;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-display-format.js